import { render, staticRenderFns } from "./guaue.vue?vue&type=template&id=6c989366&scoped=true&"
import script from "./guaue.vue?vue&type=script&lang=js&"
export * from "./guaue.vue?vue&type=script&lang=js&"
import style0 from "./guaue.vue?vue&type=style&index=0&id=6c989366&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c989366",
  null
  
)

export default component.exports